import { isNotBlank } from './string';
/**
 * Merge the given attribute
 * @param attr The attribute to merge
 * @param initialValue The initial value
 * @param form The form from which the value will be given to the mergeFunction
 */
export function serializeProperty(attr, initialValue, form) {
    var attributeName;
    // 'as any' because the actual form object is created by angular and can contain other values that need to be handled
    var attributeValue = form[attr.name];
    // Can happen e.g. when using an empty option with [value]="undefined"
    if (attributeValue === 'null') {
        attributeValue = null;
    }
    else if (attributeValue === 'undefined') {
        attributeValue = undefined;
    }
    if (isNotBlank(attr.selector)) {
        // Get the path array for the attribute ("a.b.c" => ['a', 'b', 'c']
        var path = attr.selector.split('.');
        // We don't want to create the property at this point so let's remove it (['a', 'b'])
        attributeName = path.pop();
        // Create an object structure for the given path ({ a: { b: {} } })
        var value = path.reduce(function (a, b) { return (a[b] = a[b] || {}); }, initialValue);
        // Call the deserializer function that sets the property c in the previously created object ({ a: { b: { c: ... } } })
        attr.serializer(value, form, attributeValue, attributeName);
        // Set default value if it was defined and the value is undefined after the merge function
        if (attr.defaultValue !== undefined && value[attributeName] === undefined) {
            value[attributeName] = attr.defaultValue;
        }
    }
    else {
        attributeName = String(attr.name);
        var mergeInto = {};
        attr.serializer(mergeInto, form, attributeValue, attributeName);
        var values = mergeInto[attributeName];
        for (var key in values) {
            if (values.hasOwnProperty(key)) {
                initialValue[key] = values[key];
            }
        }
    }
}
//# sourceMappingURL=serialize-property.js.map